export interface VRBOReservationAlterationItem {
  rental_id: string // "0194abd5-562b-7cfb-bbd7-58254d6bb017-tk2",
  guest_details: {
    email: string // "test.jan25@example.in",
    name: string // "Amy June29 Smith"
  }
  status: string // "NEW",
  inquiry_source: string // "vrbo",
  end_date: number // 1770109200,
  type: string // "CANCELLATION",
  external_id: string // "test-20250102-1603",
  initiated_by: 'guest' | 'host' // "guest",
  canceled: number // 0,
  start_date: number // 1769940000,
  created: number // 1767350506,
  propertyId: string // "0194abd5-562b-7cfb-bbd7-58254d6bb017-tk2",
  account: number // 1738049422.7923,
  pkey: string // "019b7e4c-92d5-7320-b0b5-38f4fac733a3-tk2",
  description: string // "Cancellation request received from Vrbo. Category: Testing me. Reason: Testing. Message: just cancel.",
  inquiry_id: string // "test-20250102-1603"
}

export function isPendingVRBOAlteration(alteration: VRBOReservationAlterationItem | null) {
  return /new/i.test(alteration?.status)
}
